import { CustomNumberFormatPipe } from 'src/app/modules/shared/pipes/custom-number-format.pipe';
import { ImportserialService } from './../../../modules/shared/services/importserial.service';
import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { noWhiteSpaceValidator, trimFirstWhiteSpaces } from './../../../modules/shared/validators/trim-white-spaces.validator';
import { PermissionService } from './../../../service/permission.service';
import { ObjectNames } from './../../../modules/shared/constants/object.names';
import { LocalDatePipe } from './../../../shared/pipes/local-date.pipe';
import { ConfigurationService } from './../../../configurations/configurationService';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { FileService } from './../../../modules/shared/services/file.service';
import { FormControlListIds } from './../../../modules/shared/constants/formcontrol-list.constants';
import { AccountService } from './../../../accounts/accountService';
import { AccountServiceN } from './../../../accounts-v2/services/account.services';
import { Status } from './../../../modules/shared/models/status';
import { User } from './../../../modules/shared/model/user.model';
import { FormErrorHandler } from './../../../modules/shared/helpers/form-error-handler.helper';
import { TemplateSection } from './../../../modules/shared/model/templateSection.model';
import { SharedCRMConfigService } from './../../../configurations/crm/shared/services/shared-crm-config.service';
import { AccountModuleId, OpportunityModuleId } from './../../../modules/shared/constants/modules.constant';
import { AppMainService } from './../../../app-main.service';
import { AppMainComponent } from './../../../app.main.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { OpportunityCustomAttributeAttachment, OpportunityCustomAttributeValue } from '../../models/opporuntity-form.model';
import { IOpportunityAdditionalDiscount, OpportunityAddEditCustomFields, OpportunityAddEditM, OpportunityAddEditProductsM } from '../../models/opportunity-add-edit.models';
import { GelAllAccountRequestModel } from '../../model/account-request.model';
import { OpportunitiesService } from '../../services/opportunity.service';
import { OPPORTUNITY_FORM_FIELDS } from '../../models/opportunity-add-edit.constants';
import { uploadFiles, validateFileSize, validateFiles } from 'src/app/modules/shared/upload-files';
import { OpportunityDetailsM } from '../../models/opportunity-details.model';
import { DatePipe, DecimalPipe } from '@angular/common';
import { CurrencySymbolPipe } from '../../../modules/shared/pipes/currency-symbol.pipe';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { toFixedDown } from '../../../modules/shared/helpers/number-value-fixed-down.helper';
import { StageOnwerSettingCode } from 'src/app/modules/shared/constants/stage-owner-setting.constants';
import { CrmSettingModel } from 'src/app/configurations/models/organization-settings.model';
import { CrmSettingsService } from 'src/app/modules/shared/services/crm-settings.service';
import { AccountWithName } from 'src/app/accounts-v2/models/accountWithName';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { ICommonProductOrderModel } from 'src/app/modules/shared/components/common-product-add-form/models/product.model'
import { OpportunityProductRequestModelBuilderService } from 'src/app/opportunities-v2/services/opportunity-product-request-model-builder.service';
import { OpportunityProductToCommonProductModelBuilderService } from '../../services/opportunity-product-to-common-product-model-builder.service';
import { TypeIds } from "src/app/inventory/sales-order/constants/constants";
import { OverlayPanel } from "primeng/overlaypanel";
import { MulticurrencyPipe } from 'src/app/modules/shared/pipes/multicurrency.pipe';

@Component({
  selector: 'app-opportunity-add-edit-dialog',
  templateUrl: './opportunity-add-edit-dialog.component.html',
  styleUrls: ['./opportunity-add-edit-dialog.component.scss'],
  providers: [CustomNumberFormatPipe]
})
export class OpportunityAddEditDialogComponent implements OnInit, OnDestroy, OnChanges {

    @Input() displayAddEditDialog: boolean = false;
    @Input() accountSelectionDisabled: boolean = false;
    @Input() selectedAccount: any;
    @Input() crudType: 'add'|'update'|'clone'|'view' = 'add';
    @Input() opportunityChannelId: number;
    @Input() accountChannelId: number;
    @Input() opportunityId: number;
    @Input() opportunityChannelList: any[] = [];

    @Output() reloadList = new EventEmitter();
    @Output() closeModal = new EventEmitter();

    @ViewChild("editCurrency") overlayPanel: OverlayPanel;

    private ngUnsubscribe$ = new Subject<void>();
    writePermission: boolean;
    editPermission: boolean;
    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
    formControlListIds = FormControlListIds;
    opportunityModuleId: number = OpportunityModuleId;
    loggedUserDetails: User;
    opportunityDetails: OpportunityDetailsM;
    opportunityViewDetails: any;
    accountDetails: any;


    //Opportunity Form Variables
    dialogHeader: 'Add Opportunity'|'Edit Opportunity'|'Clone Opportunity'|'View Opportunity' = 'Add Opportunity';
    noTemplateMessage: string = "";
    templateSections: TemplateSection[] = [];
    checkedFields: any = {};
    checkedFieldList: any = [];

    opportunityForm: FormGroup;
    formSubmitted: boolean = false;
    customAttributeValues: OpportunityCustomAttributeValue[] = [];
    loadingOpportunitySave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    detailsLoadingFailed: boolean = false;
    detailsErrorMessage: string = '';

    minDateValue = null;

    //Dropdown List
    accountList: any[] = [];
    allContactList: any[] = [];
    contactNamesForSuggestions: any[] = [];
    activeUsersList: any[] = [];
    opportunitySources: any[] = [];
    opportunityRating: any[] = [];
    allStagesDropdown: any[] = [];

    //Product Add
    addedProducts: OpportunityAddEditProductsM[] = [];
    isDisplayProductDialog: boolean = false;
    headerText = "Product List";
	moduleName = "Opportunity";
	isVisibleLocation = true;
    selectedLocation: any;
	selectedLocationId = 0;
    commonProductOrderModel: ICommonProductOrderModel;
    savedProductOrderModel: ICommonProductOrderModel;

    //inactive modal
	displayActiveInactiveModal: boolean = false;
	opportunityStatusId: number;

    //pricebook
    pricebookConfig;
    opportunityOwnerSettings: any = {};
    stageCommentEnable: boolean = false;
    selectedOwnerStageDefault: any = {};
    selectedOwnerStage: any = {};



    //decimal fractiondigits
    maximumFractionDigits: number = 6;
    qtyFractionDigits: number = 0;
    selectedTemplate = {id:0};
    selectedModule = {id: AccountModuleId, name: 'Account'};
    selectedParentAccount: any;
    accountExistMsg: string = '';
    displayManualPopup: boolean = false;
    manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
    selectedRecordList: any[] = [];

    isBundleExpanded = true;
    cols = 1;
    pTypeId = TypeIds;
    recalculateWrapper = { value: false };

    // currency
    currencies = [];
    baseCurrency: any;
    orgCurrency = [];
    currencyExchangeRate: number = 1;
    previousCurrencyExchangeRate: number = 1;

    constructor(
        private formBuilder: FormBuilder,
        private app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private sharedConfigService: SharedCRMConfigService,
        private accountService: AccountService,
        private accountServiceN: AccountServiceN,
        private opportunitiesService: OpportunitiesService,
        private fileService: FileService,
        private configurationService: ConfigurationService,
        private permissionService: PermissionService,
        private currecySymbol: CurrencySymbolPipe,
        private productsService: ProductsService,
        private timeZoneService: TimeZoneService,
        private crmSettingsService: CrmSettingsService,
        private customNumberFormatPipe: CustomNumberFormatPipe,
        private importserialService: ImportserialService,
        private columnSettingsService: SharedColumnSettingsService,
        private accountsHttpService: AccountsHttpService,
        private opportunityProductRequestModelBuilderService: OpportunityProductRequestModelBuilderService,
        private opportunityProductToCommonProductModelBuilderService: OpportunityProductToCommonProductModelBuilderService,
        private multiCurrency: MulticurrencyPipe,
    ) {
        this.loggedUserDetails = this.app.user;
     }

    ngOnInit(): void {
        this.minDateValue = this.app._showDateTimeWithZone(new Date());
        this.setPermissions();
        this.loadDropdownList();
        this.openOpportunityAddEdit();
        this.loadAllTiers();
        this.setFractionDigits();
        this.getQtyDecimalDigits();
        this.getBaseCurrency();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes?.opportunityChannelList?.currentValue){
            this.opportunityChannelList = changes?.opportunityChannelList.currentValue;
        }
        if (changes?.accountChannelId?.currentValue) {
            this.accountChannelId = changes?.accountChannelId?.currentValue;
            this.selectedTemplate.id = this.accountChannelId;
          }
    }

    setFractionDigits(){
        this.importserialService.getDecimalValue().subscribe(value=>{
            this.maximumFractionDigits = value || this.maximumFractionDigits;
        });
    }
    getQtyDecimalDigits() {
        this.importserialService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    getBaseCurrency() {
        this.importserialService
            .getOrgCurrency()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.baseCurrency = value.find((cr) => cr.isBaseCurrency);
                    this.orgCurrency = value;
                }
            });
    }

     // Set permissions for read, write, edit, delete and export
     setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();
        if (userPermissions.length) {
            let OpportunityUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY);
            const opportunityLifeCycleStageUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY_LIFE_CYCLE_STAGE);
            if (opportunityLifeCycleStageUserPermission?.permissions) {
                opportunityLifeCycleStageUserPermission.permissions = opportunityLifeCycleStageUserPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
            }

            OpportunityUserPermission = OpportunityUserPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);

            this.writePermission = OpportunityUserPermission && (OpportunityUserPermission[1].permissionId == 2 && OpportunityUserPermission[1].statusId == 1) ? true : false;
            this.editPermission = OpportunityUserPermission && (OpportunityUserPermission[2].permissionId == 3 && OpportunityUserPermission[2].statusId == 1) ? true : false;
        }
    }

    openOpportunityAddEdit(){
        switch (this.crudType) {
            case 'add':
                this.dialogHeader = 'Add Opportunity';
                this.getTemplateFormFields();
                break;
            case 'update':
                this.dialogHeader = 'Edit Opportunity';
                this.getOpportunityDetails();
                break;
            case 'clone':
                this.dialogHeader = 'Clone Opportunity';
                this.getOpportunityDetails();
                break;
            case 'view':
                this.dialogHeader = 'View Opportunity';
                this.getOpportunityDetails();
                this.getActivityList();
                break;
            default:
                break;
        }

    }

    getOpportunityDetails(){
        if(this.opportunityId>0){
            this.appMainService.isShowSpinner('getOpportunityDetails');
            this.detailsLoadingFailed = false;
            this.detailsErrorMessage = '';
            this.opportunitiesService.getOpportunityById(this.opportunityId,true).subscribe({
                next: (response: OpportunityDetailsM)=>{
                    this.appMainService.isHideSpinner('getOpportunityDetails');
                    this.opportunityDetails = response;
                    this.opportunityChannelId = this.opportunityDetails.pipelineId;
                    this.minDateValue = null;
                    this.getOpportunitStages();
                    this.formatCustomFieldValues();
                    this.getTemplateFormFields();
                    this.setCommonProductOrderModel();
                    this.fetchAccountDetailsById(this.opportunityDetails?.accountId);
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner('getOpportunityDetails');
                    this.detailsLoadingFailed = true;
                    switch (error?.status) {
                        case 404:
                          this.detailsErrorMessage = "You're not permitted to view this opportunity details!";
                          break;
                        default:
                          this.detailsErrorMessage = 'Error occurring when fetching opportunity details. Please try after sometimes.';
                          this.messageService.add({
                            severity: 'error',
                            summary: 'Error!',
                            detail: this.detailsErrorMessage,
                          });
                          break;
                    }
                }
            });
        }
    }

    getTemplateFormFields(): void {
        this.appMainService.isShowSpinner('getTemplateFormFields');
        this.sharedConfigService.getTemplateFormFields(this.opportunityModuleId, this.opportunityChannelId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.templateSections = response || [];
                    this.generateCheckFields();
                    this.noTemplateMessage = '';
                },
                error: (() => {
                    this.templateSections = [];
                    this.noTemplateMessage = 'Error loading template under this channel.';
                }),
                complete: (() => {
                    this.appMainService.isHideSpinner('getTemplateFormFields');
                })
            });
    }

    setCommonProductOrderModel() {
        this.savedProductOrderModel = this.opportunityProductToCommonProductModelBuilderService
            .buildCommonProductOrderModel(this.opportunityDetails);
    }

    generateCheckFields(){
        const checkFields = {};
        const checkedFieldList = [];
        const mergedFields = [
            ...this.templateSections[0]?.fields,
            ...this.templateSections[1]?.fields,
        ];
        OPPORTUNITY_FORM_FIELDS.map(section=>{
            section.fields.map(fieldDetails=>{
                // const checkfield = this.templateSections[0].fields.find(field=> field.field==fieldDetails.settingFieldName);
                const checkfield = mergedFields?.find(field=> field.field==fieldDetails.settingFieldName);
                checkFields[fieldDetails.formFieldname] = checkfield ? {...checkfield,formFieldname: fieldDetails.formFieldname} :{};
                checkedFieldList.push(checkFields[fieldDetails.formFieldname]);
            })
        });
        for (const { name, fields } of this.templateSections) {
            for (const fieldData of fields) {
              if (fieldData.name) {
                if (fieldData.childFields?.length) {
                  for (const childFieldData of fieldData.childFields) {
                    childFieldData.name = this.processFieldName(
                      childFieldData.name
                    );
                    checkFields[childFieldData.field] = childFieldData;
                    checkFields[childFieldData.field]['formFieldname'] = childFieldData.field;
                    checkedFieldList.push(checkFields[childFieldData.field]);
                  }
                }
              }
            }
          }
        this.checkedFieldList = ParseHelper.DeepCopy(checkedFieldList);

        this.checkedFields = checkFields;
        this.initOpportunityForm();
        this.generateCustomAttributeFields();
    }

    processFieldName(fieldName: string): string {
        // Removes all parentheses from field name
        fieldName = fieldName.split('(')[0];

        // Removes all dots from field name
        fieldName = fieldName.split('.')[0];

        // Removes all slashes from field name
        fieldName = fieldName.split('/')[0];

        // Removes all spaces from field name
        fieldName = fieldName.split(' ').join('');

        return fieldName;
    }

    initOpportunityForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        const todayUTCDate = new Date().toISOString();

        const owner = this.activeUsersList.find(user => user.id == this.loggedUserDetails.userId);
        let selectedAccount = null;

        if(this.crudType=='add' && this.selectedAccount){
            selectedAccount = {
                id: this.selectedAccount.id,
                businessName: this.selectedAccount.businessName,
                sequenceNumber: this.selectedAccount?.sequenceNumber,
                nameWithSequenceNumber: `${this.selectedAccount?.sequenceNumber} - ${this.selectedAccount.businessName}`
            };
            this.accountList = selectedAccount ? [selectedAccount] : [];
            this.getAccountDetailsById(selectedAccount?.id);
            this.getAccountContacts(selectedAccount);
        }

        this.opportunityForm = this.formBuilder.group({
            id: [0],
            sequenceNumber: [{disabled: true, value: ""},[...this.getValidators(this.checkedFields.sequenceNumber)]],
            name: ["", [...this.getValidators(this.checkedFields.name),Validators.maxLength(250),noWhiteSpaceValidator,trimFirstWhiteSpaces, Validators.pattern("^[^:]*$")]],
            description: ["", [...this.getValidators(this.checkedFields.description)]],
            accountId: [selectedAccount],
            ownerId: [owner?.id||null, [...this.getValidators(this.checkedFields.ownerId)]],
            contactId: [null],
            contactName: ["", [...this.getValidators(this.checkedFields.contactName)]],
            contactMobileNo: ["", [...this.getValidators(this.checkedFields.contactMobileNo)]],
            contactEmailAddress: ["", [...this.getValidators(this.checkedFields.contactEmailAddress),Validators.pattern("[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$")]],
            repConfidence: [null, [...this.getValidators(this.checkedFields.repConfidence)]],
            probability: [null],
            expectedDate:[null, [...this.getValidators(this.checkedFields.expectedDate)]],
            ratingId: [null, [...this.getValidators(this.checkedFields.ratingId)]],
            opportunityStageId: [null, [...this.getValidators(this.checkedFields.opportunityStageId)]],
            sourceId: [null, [...this.getValidators(this.checkedFields.sourceId)]],
            totalAmount: [0, [...this.getValidators(this.checkedFields.totalAmount)]],
            opportunityProperties: [null],
            opportunityAudit: [null],
            opportunityUnityPriceHistory: [null],
            pipelineId: [this.opportunityChannelId,[Validators.required]],
            organizationId: [this.loggedUserDetails.organizationId],
            isActive: [true],
            userId: [this.loggedUserDetails.userId],
            createdSource: [this.loggedUserDetails.userIP],
            updatedSource: [this.loggedUserDetails.userIP],
            createdBy: [this.loggedUserDetails.userId],
            updatedBy: [this.crudType == 'add' ? null : this.loggedUserDetails.userId],
            createdDate: [todayUTCDate],
            updatedDate: [this.crudType == 'add' ? null : todayUTCDate],
            isValid: [true],
            validFrom: [todayUTCDate],
            validTo: [null],
            opportunityProducts: this.formBuilder.array([]),
            customAttributeValues: this.formBuilder.array([]),
            stageOwnerId: [null],
            comment: [null],
            currentStage: [null],
        });
        this.formErrorHandler.handleErrors(this.opportunityForm, this.detailsFormErrors, {
            sequenceNumber: {
                required: "Serial No. not loaded, please reload any try again."
            },
            name: {
                required: "Enter opportunity name",
                whitespace: "Enter opportunity name",
                maxlength: "Please enter less than 250 characters",
                pattern:"Colon (:) is not allowed"
            },
            accountId: {
                required: "Select any account"
            },
            ownerId: {
                required: `Select ${this.checkedFields.ownerId?.labelName}`,
            },
            contactEmailAddress: {
                required: `Enter ${this.checkedFields.contactEmailAddress?.labelName}`,
                pattern: "Enter a valid email"
            },
            contactMobileNo: {
                required: `Enter ${this.checkedFields.contactMobileNo?.labelName}`
            },
            opportunityStageId: {
                required: `Select ${this.checkedFields.opportunityStageId?.labelName}`,
            },
            repConfidence: {
                required: `Enter ${this.checkedFields.repConfidence?.labelName}`,
            },
            sourceId: {
                required: `Select ${this.checkedFields.sourceId?.labelName}`,
            },
            ratingId: {
                required: `Select ${this.checkedFields.ratingId?.labelName}`,
            },
            pipelineId: {
                required: `Select Opportunity Channel`,
            },
        });

        this.setDefaultStage();

        if(this.crudType=='add' || this.crudType=='clone'){
            this.generateSequenceNumber();
        }

        if(this.crudType!=='add'){
            this.setOpportunityFormDetails();
            this.generateOpportunityView()
        }

        this.opportunityForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);
        this.itemTotalCalulationInit();
    }

    selectedOpportunityChannel(selectedOpportunityChannelId){
        if(selectedOpportunityChannelId){
            this.opportunityChannelId = selectedOpportunityChannelId;
            this.crudType = 'add';
            this.loadDropdownList();
            this.openOpportunityAddEdit();
            this.loadAllTiers();
            // this.getTemplateFormFields();
        }
    }

    setDefaultStage(){
        if(this.crudType=='add' && this.allStagesDropdown?.length>0 && this.opportunityForm){
            this.selectedOwnerStageDefault = this.allStagesDropdown[0]?.id;
            this.opportunityForm.patchValue({
                opportunityStageId: this.selectedOwnerStageDefault
            });

            this.selectedOpportunityStage(this.selectedOwnerStageDefault);
        }

        if(this.crudType=='update' && this.opportunityForm){
            this.selectedOwnerStageDefault = this.opportunityDetails?.opportunityStageId;
        }
    }

    setOpportunityFormDetails(){
        const todayUTCDate = new Date().toISOString();
        const selectedAccount = this.opportunityDetails.account ? {
            id: this.opportunityDetails.account.id,
            businessName: this.opportunityDetails.account.businessName,
            sequenceNumber: this.opportunityDetails.account?.sequenceNumber,
            nameWithSequenceNumber: `${this.opportunityDetails.account?.sequenceNumber} - ${this.opportunityDetails.account.businessName}`
        } : null;
        this.accountList = selectedAccount ? [selectedAccount] : [];

        if(this.opportunityDetails?.account?.typeId){
            this.accountChannelId = this.opportunityDetails?.account?.typeId;
        }

        this.opportunityForm.patchValue({
            id: (this.crudType!=='clone') ? this.opportunityDetails.id : 0,
            name: this.opportunityDetails.name,
            description: this.opportunityDetails?.description||"",
            accountId: selectedAccount,
            ownerId: this.opportunityDetails?.ownerId,
            contactMobileNo: this.opportunityDetails?.contactMobileNo||"",
            contactEmailAddress: this.opportunityDetails?.contactEmailAddress||"",
            repConfidence: this.opportunityDetails?.repConfidence != null ? this.opportunityDetails?.repConfidence : null,
            probability: this.opportunityDetails?.probability,
            expectedDate: this.opportunityDetails?.expectedDate ? new Date(this.opportunityDetails.expectedDate) : null,
            ratingId: this.opportunityDetails.ratingId,
            opportunityStageId: this.opportunityDetails.opportunityStageId,
            sourceId: this.opportunityDetails.sourceId,
            totalAmount: (this.opportunityDetails.netAmount||0) * (this.opportunityDetails?.exchangeRate ? this.opportunityDetails?.exchangeRate : this.baseCurrency?.exchangeRate ?? 1),
            isActive: this.opportunityDetails.statusId==Status.Active ? true : false,
            userId: this.opportunityDetails?.userId||this.loggedUserDetails.userId,
            createdSource: this.opportunityDetails?.createdSource||this.loggedUserDetails.userIP,
            createdBy: this.opportunityDetails?.createdBy||this.loggedUserDetails.userId,
            createdDate: this.opportunityDetails?.createdDate||todayUTCDate,
            validFrom: this.opportunityDetails?.validFrom||todayUTCDate,
            validTo: this.opportunityDetails?.validTo||null,
            stageOwnerId: this.opportunityDetails?.stageOwnerId,
            comment: this.opportunityDetails?.comment,
            currentStage: this.opportunityDetails?.currentStage,
        });

        if(this.crudType=='update' || this.crudType=='view'){
            this.opportunityForm.patchValue({
                sequenceNumber: this.opportunityDetails.sequenceNumber
            })
        }

        if(selectedAccount){
            this.getAccountContacts(selectedAccount,this.opportunityDetails?.contactName);
        }
        this.setOpportunityProducts();
    }

    setOpportunityProducts(){
        let warehouseId = 0;
        this.addedProducts = [];
        // this.opportunityDetails.opportunityProducts.map(x=> {
        //     const addedProduct = this.formatedProductDetails(x);
        //     warehouseId = x?.warehouseId ?? warehouseId;
        //     this.addedProducts.push({...addedProduct,id: addedProduct.productId});
        //     this.addProduct(addedProduct);
        // });

        this.selectedLocationId = warehouseId;
    }

    formatedProductDetails(x: any){
        let qty = x.qty||0;
        let price = x.price||0;

        let product = x.product ? x.product : null;
        let unit = product && product.productUOM && product.productUOM.length > 0 ?
                    product.productUOM.find(y => y.unitOfMeasureId == x.uomId) : null;

        // const addedProduct: OpportunityAddEditProductsM = {
        //     id: (this.crudType!=='clone') ? x.id : 0,
        //     createdSource: x?.createdSource||this.loggedUserDetails.userIP,
        //     updatedSource: this.loggedUserDetails.userIP,
        //     createdBy: x?.createdBy||this.loggedUserDetails.userId,
        //     updatedBy: this.loggedUserDetails.userId,
        //     createdDate: x?.createdDate||new Date().toISOString(),
        //     updatedDate: new Date().toISOString(),
        //     opportunityId: (this.crudType!=='clone') ? this.opportunityDetails.id : 0,
        //     productId: x.productId,
        //     itemNo: product?.itemNo||"",
        //     description: product?.description||"",
        //     uomId: x?.uomId||null,
        //     uom: product?.productUOM||[],
        //     unit: unit,
        //     qty: qty,
        //     price: price,
        //     totalAmount: qty * price,
        //     statusId: Status.Active,
        //     warehouseId: x?.warehouseId ?? 0,
        // }

        // return addedProduct;
        return null;
    }

    generateSequenceNumber(){
        this.configurationService.generateSequenceNumberByModuleId(OpportunityModuleId).subscribe((response)=>{
            this.opportunityForm.get('sequenceNumber').setValue(response)
        });
    }

    //Custom Attributes

    generateCustomAttributeFields(){
        if(this.templateSections?.length>0){
            const todayUTCDate = new Date().toISOString();

            this.templateSections[0]?.customFields?.filter(f=> f.enabledInForm).map(customField=>{

                let pickListValues: any[] = customField?.formControl?.pickListValues||[];

                if([FormControlListIds.DropDownList,FormControlListIds.MultipleDropDownList].includes(customField?.formControl.id)){
                    pickListValues = customField?.formControl?.pickListValues?.map(x=> {return {name: x}})||[];
                }

                let addedCustomField: OpportunityAddEditCustomFields = null;

                if(this.opportunityDetails?.customAttributeValues?.length>0){
                    addedCustomField = this.opportunityDetails?.customAttributeValues.find(x=> x.customAttributeId == customField.customAttributeId);
                }

                if(addedCustomField && addedCustomField?.multipleCheckBox?.length>0){
                    const availableAddedValues = [];
                    addedCustomField.multipleCheckBox.map(pickName=>{
                        const exist = pickListValues.find(p=> p==pickName);
                        if(exist)availableAddedValues.push(exist);
                    });
                    addedCustomField.multipleCheckBox = availableAddedValues?.length>0 ? availableAddedValues : null;
                }

                if(addedCustomField && addedCustomField?.multipleValues?.length>0){
                    const availableAddedValues = [];
                    addedCustomField.multipleValues.map(list=>{
                        const multi = pickListValues.find(p=> p?.name==list?.name);
                        if(multi)availableAddedValues.push(multi);
                    });
                    addedCustomField.multipleValues = availableAddedValues?.length>0 ? availableAddedValues : null;
                }

                let defaultValue = "";

                if([FormControlListIds.Number,FormControlListIds.Decimal].includes(customField.formControl.id)){
                    defaultValue = null;
                }

                const fieldDetails: OpportunityAddEditCustomFields = {
                    id: (this.crudType!=='clone' && addedCustomField) ? addedCustomField.id : 0,
                    objectId: OpportunityModuleId,
                    objectValue: (this.crudType!=='clone' && this.opportunityDetails) ? this.opportunityDetails.id : 0,
                    customAttribute: {...customField, formControl: {...customField.formControl, name: customField.formControl.type, type: null}},
                    customAttributeId: customField.customAttributeId,
                    formControlId: customField.formControl.id,
                    isRequired: customField.isRequired,
                    maxLengthAfterDecimal: customField.formControl?.maxLengthAfterDecimal||null,
                    field: customField.field,
                    labelName: customField.labelName,
                    readOnly: customField?.readOnly,
                    isMapped: customField?.isMapped,
                    isProjected: customField?.isProjected,
                    pickListValues: pickListValues,
                    value: addedCustomField?.value||defaultValue,
                    values: addedCustomField?.values||null,
                    multipleValues: addedCustomField?.multipleValues||null,
                    multipleCheckBox: addedCustomField?.multipleCheckBox||null,
                    ratingId: addedCustomField?.ratingId||0,
                    toggle: addedCustomField?.toggle||false,
                    customeAttachement: addedCustomField?.customeAttachement||null,
                    createdSource: addedCustomField?.createdSource||this.loggedUserDetails.userIP,
                    updatedSource: this.loggedUserDetails.userIP,
                    createdBy: addedCustomField?.createdBy||this.loggedUserDetails.userId,
                    updatedBy: this.loggedUserDetails.userId,
                    createdDate: addedCustomField?.createdDate||todayUTCDate,
                    updatedDate: todayUTCDate
                }


                this.addCustomAttribute(fieldDetails);
            })
        }
    }

    initCustomAttribute(customAttribute: OpportunityAddEditCustomFields){
        const todayUTCDate = new Date().toISOString();

        const attachmentControlId = [FormControlListIds.Picture,FormControlListIds.FileUpload].includes(customAttribute.formControlId) ? customAttribute.formControlId : FormControlListIds.FileUpload;
        const inputControlId = [FormControlListIds.InputBox,FormControlListIds.DatePicker,FormControlListIds.RadioButton,FormControlListIds.Number,FormControlListIds.Decimal].includes(customAttribute.formControlId) ? customAttribute.formControlId : FormControlListIds.InputBox;

        return this.formBuilder.group({
            id: [customAttribute.id],
            objectId: [customAttribute.objectId],
            objectValue: [customAttribute.objectValue],
            customAttribute: [customAttribute.customAttribute],
            customAttributeId: [customAttribute.customAttributeId],
            formControlId: [customAttribute.formControlId],
            maxLengthAfterDecimal: [customAttribute.maxLengthAfterDecimal],
            field: [customAttribute.field],
            labelName: [customAttribute.labelName],
            isRequired: [customAttribute.isRequired],
            readOnly: [customAttribute?.readOnly],
            isMapped: [customAttribute?.isMapped],
            isProjected: [customAttribute?.isProjected],
            pickListValues: [customAttribute.pickListValues],
            value: [customAttribute.value,[...this.getCustomValidators(customAttribute,inputControlId)]],
            values: [customAttribute.values,[...this.getCustomValidators(customAttribute,FormControlListIds.DropDownList)]],
            multipleValues: [customAttribute.multipleValues,[...this.getCustomValidators(customAttribute,FormControlListIds.MultipleDropDownList)]],
            multipleCheckBox: [customAttribute.multipleCheckBox,[...this.getCustomValidators(customAttribute,FormControlListIds.CheckBox)]],
            ratingId: [customAttribute.ratingId,[...this.getCustomValidators(customAttribute,FormControlListIds.Rating)]],
            toggle: [customAttribute.toggle,[...this.getCustomValidators(customAttribute,FormControlListIds.ToggleButton)]],
            customeAttachement: [customAttribute.customeAttachement,[...this.getCustomValidators(customAttribute,attachmentControlId)]],
            statusId: [Status.Active],
            createdSource: [customAttribute?.createdSource||this.loggedUserDetails.userIP],
            updatedSource: [this.loggedUserDetails.userIP],
            createdBy: [customAttribute?.createdBy||this.loggedUserDetails.userId],
            updatedBy: [this.loggedUserDetails.userId],
            createdDate: [customAttribute?.createdDate||todayUTCDate],
            updatedDate: [todayUTCDate],
        });
    }

    getAddedCustomAttributes(form) {
        return form.controls.customAttributeValues.controls;
    }

    addCustomAttribute(customAttribute: OpportunityAddEditCustomFields) {
        const control = <FormArray>this.opportunityForm.get('customAttributeValues');
        control.push(this.initCustomAttribute(customAttribute));
    }

    getCustomValidators(customAttribute: OpportunityAddEditCustomFields, formControlId: number): any[] {
        const validators = [];

        if (customAttribute?.isRequired && customAttribute.formControlId==formControlId) {
            validators.push(Validators.required);
        }

        return validators;
    }

    isRequiredTouched(control: FormGroup): boolean {
        return control?.invalid && control?.touched;
    }

    onCustomUpload(event, customField: FormGroup, type): void {
        for (let file of event.files) {
            let errors = [];
            this.appMainService.isShowSpinner('uploadFile');
            if (type == 'image') {
                errors = validateFiles(file, 2, this.allowedExtensions);
            }else{
                errors = validateFileSize(file, 2);
            }

            if (errors.length) {
                for (let error of errors) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.fileName + ": " + error.error
                    });
                }
                this.appMainService.isHideSpinner('uploadFile');
            } else {
                uploadFiles(file, ({ name, content, size, extension }) => {

                    const customAttachment: OpportunityCustomAttributeAttachment = {
                        name: name,
                        extension: extension,
                        content: content,
                        sizeInBytes: size
                    }

                    const addedAttachments = customField.value.customeAttachement||[];
                    const alreadyAdded = addedAttachments.find(f => f.name === customAttachment.name);

                    if(!alreadyAdded){
                        addedAttachments.push(customAttachment);
                        customField.patchValue({
                            customeAttachement: addedAttachments
                        })
                    }else{
                        this.messageService.add({ severity: 'warn', summary: 'Exist', detail: `${customAttachment.name} already added.` });
                    }

                    this.appMainService.isHideSpinner('uploadFile');
                });
            }
        }
    }

    removeCustomFile(index: number, customField: FormGroup) {
        const addedAttachments = customField.value.customeAttachement||[];
        addedAttachments.splice(index, 1);
        customField.patchValue({
            customeAttachement:addedAttachments ?? []
        })
    }

    downloadFile(name, content): void {
        this.fileService.downloadFile(name, content);
    }

    //Custom Attributes End

    onChangeProducts(event: ICommonProductOrderModel){
        this.commonProductOrderModel = event;
        if(this.commonProductOrderModel){
            this.opportunityForm.patchValue({
                totalAmount: this.commonProductOrderModel?.totalAmount ?? 0
            },{onlySelf: true, emitEvent: false})
        }
    }

    initOpportunityProduct(addedProduct: OpportunityAddEditProductsM = null){
        const todayUTCDate = new Date().toISOString();
        return this.formBuilder.group({
            id: [addedProduct?.id||0],
            opportunityId: [addedProduct?.opportunityId||0],
            productId: [addedProduct?.productId||null],
            itemNo: [addedProduct?.itemNo||""],
            description: [addedProduct?.description||""],
            uomList: [(addedProduct?.uom||[])],
            uomId:[addedProduct?.uomId||null],
            unit: [addedProduct?.unit||null],
            qty: [addedProduct?.qty||0],
            price: [addedProduct?.price||0],
            totalAmount: [addedProduct?.totalAmount||0],
            statusId: [Status.Active],
            warehouseId: [addedProduct?.warehouseId||null],
            createdSource: [addedProduct?.createdSource||this.loggedUserDetails.userIP],
            updatedSource: [this.loggedUserDetails.userIP],
            createdBy: [addedProduct?.createdBy||this.loggedUserDetails.userId],
            updatedBy: [this.loggedUserDetails.userId],
            createdDate: [addedProduct?.createdDate||todayUTCDate],
            updatedDate: [todayUTCDate],
        });
    }

    getAddedProducts(form) {
        return form.controls.opportunityProducts.controls;
    }

    addProduct(addedProduct: OpportunityAddEditProductsM = null) {
        const control = <FormArray>this.opportunityForm.get('opportunityProducts');
        control.push(this.initOpportunityProduct(addedProduct));
    }

    removeProduct(index: number) {
        const control = <FormArray>this.opportunityForm.get('opportunityProducts');
        control.removeAt(index);
    }

    getProductByIndex(index: number) {
        const control = <FormArray>this.opportunityForm.get('opportunityProducts');
        return control.controls[index];
    }

    getValidators(fieldData: any): any[] {
        const validators = [];

        if (fieldData?.enabledInForm && fieldData?.isRequired) {
            validators.push(Validators.required);
        }

        return validators;
    }

    onProductAddComplete(event) {
		this.isDisplayProductDialog = false;
		event = event ? event : [];
		let newProducts = [];
		const opportunityProducts = this.opportunityForm.value.opportunityProducts ? this.opportunityForm.value.opportunityProducts : [];

		event.map(item => {
			let product = opportunityProducts.find(x => x.productId == item.id);
			(product == null) && newProducts.push(item);
		});

        opportunityProducts.map((addedProduct, index)=>{
            let product = event.find(x => x.id == addedProduct.productId);
            if(!product) this.removeProduct(index);
        });

		newProducts.map(x => {
            let addedProductId: number = 0;

            if(this.crudType=='update' && this.opportunityDetails?.opportunityProducts?.length>0){
                addedProductId = this.opportunityDetails?.opportunityProducts.find(p=> p.productId==x.id)?.id||0;
            }

			let qty = x.unit && x.unit.uomDetail.value ? x.unit.uomDetail.value : 0;
			let price = x.price ? parseFloat(x.price) : 0;
			// const addedProduct: OpportunityAddEditProductsM = {
			// 	id: addedProductId,
			// 	createdSource: this.loggedUserDetails.userIP,
			// 	updatedSource: this.loggedUserDetails.userIP,
			// 	createdBy: this.loggedUserDetails.userId,
			// 	updatedBy: this.loggedUserDetails.userId,
			// 	createdDate: new Date().toISOString(),
			// 	updatedDate: new Date().toISOString(),
			// 	opportunityId: this.opportunityForm.value.id,
			// 	productId: x.id,
			// 	itemNo: x.itemNo,
			// 	description: x.description,
			// 	uomId: x?.unit?.uomDetail ? x.unit?.uomDetail?.id : null,
			// 	uom: x.uom||[],
			// 	unit: x.unit ? x.unit : null,
			// 	qty: qty,
			// 	price: price,
			// 	totalAmount: qty * price,
			// 	statusId: Status.Active,
			// 	warehouseId: this.selectedLocation?.id ?? 0,
			// }

            // this.addProduct(addedProduct);
		});
	}

    itemTotalCalulationInit(){
        this.opportunityForm.get('opportunityProducts')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                this.calculateTotal(value);
            });
    }

    calculateTotal(addedProducts: OpportunityAddEditProductsM[]) {
		let totalAmount = 0;
        this.addedProducts = [];
		addedProducts.map((element, index) => {
			const qty = element.qty>0 ? element.qty : 0;
			const price = element.price>0 ? element.price : 0;
			const itemTotal = element.qty * element.price;
			totalAmount = totalAmount + itemTotal;

            const productForm = this.getProductByIndex(index);
            productForm.patchValue({
                qty: qty,
                price: price,
                totalAmount: itemTotal
            },{onlySelf: true, emitEvent: false})

            this.addedProducts.push({...productForm.value,id: productForm.value.productId});
		});

        this.opportunityForm.patchValue({
            totalAmount: totalAmount
        },{onlySelf: true, emitEvent: false})
	}

    openAddProductDialog() {
		this.isDisplayProductDialog = true;
	}

    cancelProductAdd(event) {
		this.isDisplayProductDialog = false;
        this.setAddedProducts();
	}

    onLocationSelect(e) {
		this.selectedLocation = e;
	}

    setAddedProducts(){
        this.addedProducts = [];
        this.opportunityForm.value.opportunityProducts?.map(addedProduct=>{
            this.addedProducts.push({...addedProduct,id: addedProduct.productId});
        });
    }

    selectedOpportunityStage(stageId: number) {
        this.selectedOwnerStage = this.allStagesDropdown.find(stage => stage.id == stageId);
        if (this.selectedOwnerStage) {
            if(this.selectedOwnerStageDefault == stageId){
                this.stageCommentEnable = false;
                this.opportunityForm.patchValue({ comment: null });
              }else{
                this.stageCommentEnable =  true;
            }
            this.opportunityForm.patchValue({
                probability: this.selectedOwnerStage?.probability || 0,
                currentStage: this.selectedOwnerStage?.name || null,
            }, { onlySelf: true, emitEvent: false })
        }
    }

    //Account Selection
    searchAccount(accountName: string = "") {

        if(!accountName){
            this.accountList = [];
            return;
        }

        const requestModel: GelAllAccountRequestModel = {
            channelId: this.accountChannelId,
            stageId: null,
            isActive: true,
            globalSearchValue: accountName,
            selectableColumns: [
                {columnName: "businessName",isCustom: false},
                {columnName: "sequenceNumber",isCustom: false},
                {columnName: "nameWithSequenceNumber",isCUstom: false}
            ],
            filter: null,
            pageSize: 0,
            pageNumber: 0,
            sortByColumn: null,
            isSortByDescending: true,
            filterInColumns: []
        }

        this.appMainService.isShowSpinner('getAccountList');

        this.accountServiceN.getAccountsList(requestModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (response) => {
                if (response) {
                    this.accountList = response?.list?.length>0 ? response?.list.slice(0, 1000)  :[];
                }
                this.appMainService.isHideSpinner('getAccountList');
            },
            error: (error) => {

                this.appMainService.isHideSpinner('getAccountList');
            },
            complete: () => {
                this.appMainService.isHideSpinner('getAccountList');

            }
        })
    }

    getAccountContacts(account: any, contactName: any = "") {
        this.appMainService.isShowSpinner('GetDetails');
        this.accountService.getAccountContactNameList(account.id).subscribe({
            next:  res => {
                this.appMainService.isHideSpinner('GetDetails');
                this.allContactList = res.filter((el) => el.contact && el.contact != null);
                this.contactNamesForSuggestions = this.allContactList;

                if (contactName) {
                    this.setContactNameFromApi(contactName)
                } else {
                    this.opportunityForm.patchValue({
                        contactEmailAddress: "",
                        contactMobileNo: ""
                    })
                }
            },
            error: err => {
                 this.appMainService.isHideSpinner('GetDetails');
            }

        });
    }

    //set contactname while showing preloaded values on edit popup
	private setContactNameFromApi(value) {
		let selectedContact = this.allContactList.length > 0 ? this.allContactList.find(contact => contact.contactName == value) : null;

        if(!selectedContact){
            selectedContact = {
                contactName: value
            };
            this.allContactList.push(selectedContact);
        }

		this.opportunityForm.patchValue({
            contactName: selectedContact
        })
	}

    searchContact(query) {
		const filtered: any[] = [];
		if (this.allContactList.length) {
			for (let i of this.allContactList) {
				let associationName = i;
				if (associationName.contactName.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
					filtered.push(associationName);
				}
			}
		}
		this.contactNamesForSuggestions = filtered.length ? [...filtered] : [];
	}


    getContactsDetails(value) {
		if (!value.contact) {
			return;
		}
		const contactEmailAddress = value.contact.contactEmails && value.contact.contactEmails[0] && value.contact.contactEmails[0].email && value.contact.contactEmails[0].email.emailAddress ? value.contact.contactEmails[0].email.emailAddress : '';
		const contactMobileNo = value.contact.contactPhones && value.contact.contactPhones[0] && value.contact.contactPhones[0].phone && value.contact.contactPhones[0].phone.number ? value.contact.contactPhones[0].phone.number : '';

        this.opportunityForm.patchValue({
            contactEmailAddress: contactEmailAddress,
            contactMobileNo: contactMobileNo
        })
    }

    //#region ***Add/Edit/Clone***
    saveOpportunity(type: 'view'|'save' = 'save'){
        if(this.opportunityForm.invalid){
            this.opportunityForm.markAllAsTouched();
            this.opportunityForm.markAsDirty();
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }
        this.formSubmitted = true;
        const formValue = this.opportunityForm.getRawValue();
        let opportunityData: OpportunityAddEditM = ParseHelper.DeepCopy(formValue);
        opportunityData.customAttributeValues = this.formCustomValuesForSave(opportunityData.customAttributeValues);
        opportunityData.accountId = formValue.accountId?.id||null;
        opportunityData.totalAmount = opportunityData.totalAmount||0;
        // opportunityData.contactId = formValue.contactName?.contactId||null;
        opportunityData.contactName = formValue.contactName?.contactName||formValue.contactName||"";
        opportunityData.expectedDate = this.timeZoneService._getCustomDateString(formValue.expectedDate);
        opportunityData.statusId = formValue.isActive ? Status.Active : Status.InActive;

        if(this.crudType=='add' || this.crudType=='clone'){
            opportunityData.sequenceNumber = null;
        }

        // if(this.crudType=='update' && this.opportunityDetails?.opportunityProducts?.length>0){
        //     this.opportunityDetails?.opportunityProducts.map(x=>{
        //         const addedProduct = opportunityData?.opportunityProducts.find(p=> p.id==x.id);

        //         if(!addedProduct){
        //             opportunityData.opportunityProducts = opportunityData.opportunityProducts||[];
        //             const productDetails = this.formatedProductDetails(x);
        //             opportunityData.opportunityProducts.push({...productDetails, statusId: Status.Deleted});
        //         }
        //     });
        // }


        if(this.commonProductOrderModel && this.commonProductOrderModel?.products && this.commonProductOrderModel?.products?.length > 0){
            let mappedObj = this.opportunityProductRequestModelBuilderService.mapProductsToOpportunity(this.commonProductOrderModel?.products, this.crudType == "clone" ? 0 : this.opportunityForm.value.id, this.crudType);
            opportunityData.opportunityProducts = mappedObj?.opportunityProducts ?? [];
        }
        opportunityData.opportunityAddDiscount = this.commonProductOrderModel ? this.mapToOpportunityAdditionalDiscount(this.commonProductOrderModel, this.opportunityForm.value.id) : [];
        this.prepareOpportunityTotalData(opportunityData);

        if(this.opportunityForm.value.id>0){
            this.appMainService.isShowSpinner('updateOpportunity');
			this.opportunitiesService.updateOpportunity(opportunityData, this.isBaseCurrency()).subscribe({
                next: (response)=>{
                    this.appMainService.isHideSpinner('updateOpportunity');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Opportunity updated successfully...' });
                    this.reloadList.emit(response);
                    this.formSubmitted = false;
                    if(type=='view'){
                        this.opportunityId = response.id;
                        this.crudType = 'view';
                        this.openOpportunityAddEdit();
                    }else{
                        this.closeOpportunityDialog();
                    }
                },
                error: (error)=>{
                    this.formSubmitted = false;
                    this.appMainService.isHideSpinner('updateOpportunity');
                    this.messageService.add({ severity: 'error', summary: 'Failed to Add', detail: 'Error occurred while saving data, please try again.' });
                }
            })
        }else{
            this.appMainService.isShowSpinner('addOpportunity');
			this.opportunitiesService.addOpportunity(opportunityData, this.isBaseCurrency()).subscribe({
                next: (response)=>{
                    this.appMainService.isHideSpinner('addOpportunity');
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Opportunity added successfully...' });
                    this.reloadList.emit(response);
                    this.formSubmitted = false;
                    if(type=='view'){
                        this.opportunityId = response.id;
                        this.crudType = 'view';
                        this.openOpportunityAddEdit();
                    }else{
                        this.closeOpportunityDialog();
                    }
                },
                error: (error)=>{
                    this.formSubmitted = false;
                    this.appMainService.isHideSpinner('addOpportunity');
                    this.messageService.add({ severity: 'error', summary: 'Failed to Add', detail: 'Error occurred while saving data, please try again.' });
                }
            })
        }
    }

    mapToOpportunityAdditionalDiscount(orderResponse: any, opportunityId: number): IOpportunityAdditionalDiscount[] {
        const { additionalDiscount, additionalDiscountAmount, additionalDiscountRate } = orderResponse;
        
        if (!additionalDiscount) return [];
        
        const discountId = additionalDiscount.id;
        const discountTypeId = additionalDiscount.discountBy; 
        const description = additionalDiscount.additionalDescription;
        const discount = {
            id: this.opportunityForm.value.id > 0 ? additionalDiscount.id : 0,
            opportunityId: opportunityId,
            discountId: discountId,
            discountTypeId: discountTypeId,
            discountAmount: additionalDiscountAmount,
            discountRate: additionalDiscountRate,
            description: description,
        };
        return [discount];
    }
    prepareOpportunityTotalData(opportunityData){
        opportunityData.discountId = this.commonProductOrderModel?.discount?.id ?? 0;
        opportunityData.discountRate = this.commonProductOrderModel?.discountRate ?? 0;
        opportunityData.discountTypeId = this.commonProductOrderModel?.discount?.discountBy ?? 0;
        opportunityData.discountAmount = this.commonProductOrderModel?.discountAmount ?? 0;
        opportunityData.additionalDiscount = this.commonProductOrderModel?.additionalDiscountAmount ?? 0;
        opportunityData.additionalFeesId = this.commonProductOrderModel?.handlingFee?.id ?? 0;
        opportunityData.additionalRate = this.commonProductOrderModel?.handlingFeeRate ?? 0;
        opportunityData.additionalAmount = this.commonProductOrderModel?.handlingFeeAmount ?? 0;
        opportunityData.taxId = 0; 
        opportunityData.taxName = "";
        opportunityData.taxRateTypeId = 0;
        opportunityData.taxRate = 0;
        opportunityData.taxAmount = this.commonProductOrderModel?.taxAmount ?? 0;
        opportunityData.shippingChargeAmount = this.commonProductOrderModel?.shippingCharge ?? 0;
        opportunityData.totalAmount = this.commonProductOrderModel?.orderSubtotal ?? 0;
        opportunityData.netAmount = this.commonProductOrderModel?.products?.length > 0 ? this.commonProductOrderModel?.totalAmount ?? 0 : this.opportunityForm?.controls?.totalAmount?.value ?? 0;
        opportunityData.currencyUnitId = this.accountDetails?.currencyId ?? 0;
        opportunityData.exchangeRate = this.currencyExchangeRate ?? this.baseCurrency?.exchangeRate;
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    //#endregion

    //#region ***Dropdown List ***

    loadDropdownList(){
        this.activeUsersList = this.app.usersList.filter(obj => obj.statusId == 1);
        this.getAllSources();
        this.getAllRatings();
        this.opportunityChannelId && this.getOpportunitStages();
    }

    getAllSources(){
        this.opportunitiesService.getAllSources(this.loggedUserDetails.organizationId).pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (sources) =>{
                this.opportunitySources = sources || [];
            }
        });
    }

    getAllRatings(){
        this.opportunitiesService.getAllRatings().pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: (ratings)=>{
                this.opportunityRating = ratings;
            }
        });
    }

    getOpportunitStages(): void {
        this.opportunitiesService.getStageList(OpportunityModuleId,this.opportunityChannelId,false)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response: any) => {
                    this.allStagesDropdown = response?.filter(x=> x.id && x.id>0) || [];
                    this.setDefaultStage();
                }
            });
    }

    //#endregion

    //#region ***Opportunity View***

    generateOpportunityView(){
        const totalAmount = this.opportunityDetails.totalAmount ? this.multiCurrency.transform(this.opportunityDetails.totalAmount, (this.opportunityDetails?.exchangeRate ? this.opportunityDetails?.exchangeRate : this.baseCurrency?.exchangeRate ?? 1), (this.opportunityDetails?.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.maximumFractionDigits) : 0.00;
        const netAmount = this.opportunityDetails.netAmount ? this.multiCurrency.transform(this.opportunityDetails.netAmount, (this.opportunityDetails?.exchangeRate ? this.opportunityDetails?.exchangeRate : this.baseCurrency?.exchangeRate ?? 1), (this.opportunityDetails?.currencyUnit?.symbol ?? this.baseCurrency?.symbol), this.maximumFractionDigits) : 0.00;
        const accountSNumber = this.opportunityDetails?.account?.sequenceNumber ? `${this.opportunityDetails?.account?.sequenceNumber} - ` : "";
        const accountName: string = this.opportunityDetails?.account ? `${accountSNumber}${this.opportunityDetails?.account?.businessName}` : "";
        const opportunityViewDetails = {
            id: this.opportunityDetails.id,
            sequenceNumber: this.opportunityDetails.sequenceNumber,
            name: this.opportunityDetails.name,
            description: this.opportunityDetails?.description||"",
            accountId: accountName||"",
            ownerId: this.opportunityDetails?.ownerName,
            contactName: this.opportunityDetails?.contactName,
            contactMobileNo: this.opportunityDetails?.contactMobileNo||"",
            contactEmailAddress: this.opportunityDetails?.contactEmailAddress||"",
            repConfidence: this.opportunityDetails?.repConfidence ? `${this.opportunityDetails?.repConfidence}%` : "",
            probability: this.opportunityDetails?.probability ? `${this.opportunityDetails?.probability}%` : "",
            forcastCategory: this.opportunityDetails?.forcastCategory,
            expectedDate: this.opportunityDetails?.expectedDate ? new DatePipe('en').transform(this.opportunityDetails?.expectedDate, 'MM/dd/yyyy') : null,
            ratingId: this.opportunityDetails.ratingName||"",
            opportunityStageId: this.opportunityDetails?.opportunityStages ? `${this.opportunityDetails?.opportunityStages?.name}` : "",
            sourceId: this.opportunityDetails?.sourceName||"",
            totalAmount:  netAmount,
            organizationId: this.loggedUserDetails.organizationId,
            isActive: this.opportunityDetails.statusId==Status.Active ? true : false,
            userId: this.opportunityDetails?.userId||this.loggedUserDetails.userId,
            createdSource: this.opportunityDetails?.createdSource||this.loggedUserDetails.userIP,
            createdBy: this.opportunityDetails?.createdBy||this.loggedUserDetails.userId,
            createdByUserName: this.opportunityDetails?.createdByUserName,
            createdDate: this.opportunityDetails?.createdDate ? new LocalDatePipe().transform(this.opportunityDetails?.createdDate,'MM/DD/YYYY') : null,
            validFrom: this.opportunityDetails?.validFrom,
            validTo: this.opportunityDetails?.validTo,
            // opportunityProducts: this.opportunityDetails.opportunityProducts?.map((x: any)=> {
            //     let product = x.product ? x.product : null;
            //     let unit = product && product.productUOM && product.productUOM.length > 0 ?
			// 			product.productUOM.find(y => y.unitOfMeasureId == x.uomId) : null;
            //     return {
            //         ...x,
            //         unit: unit
            //     }
            // }),
            opportunityProducts: 
            this.opportunityDetails.opportunityProducts?.map((x: any) => {
                let product = x.product ? x.product : null;
                let unit = x && x.uom && x.uom.length > 0 ? x.uom?.find((y) => y.unitOfMeasureId == x.uomId) : null;
                let taxSumAmount = x.opportunityProductSubTax?.reduce((sum, subTax) => sum + (subTax.taxAmount || 0), 0) || 0;
                let bundleTaxAmount = x.opportunityBundleProducts?.reduce((sum, bundle) => sum + (bundle.taxRate || 0), 0) || 0;
                let updatedOpportunityBundleProducts = x.opportunityBundleProducts?.map((bundle: any) => {
                  let totalBundleTaxAmount = bundle.opportunityBundleDetailSubTax?.reduce((sum, subTax) => sum + (subTax.taxAmount || 0), 0) || 0;
                  let bunit = bundle && bundle.uom && bundle.uom.length > 0 ? bundle.uom?.find((y) => y.unitOfMeasureId == bundle.uomId) : null;
                  return {
                    ...bundle,
                    unit: bunit,
                    totalBundleTaxAmount,
                  };
                });
                return {
                  ...x,
                  unit: unit,
                  taxSumAmount: taxSumAmount,
                  bundleTaxAmount: bundleTaxAmount,
                  opportunityBundleProducts: updatedOpportunityBundleProducts,
                };
              }),
            customAttributeValues: {},
            currentStage: this.opportunityDetails?.currentStage,
            previousStage: this.opportunityDetails?.previousStage,
            stageChangedBy: this.opportunityDetails?.stageChangedBy,
            stageChangedDate: new LocalDatePipe().transform(this.opportunityDetails?.stageChangedDate,'MM/DD/YYYY'),
            activeInactiveStatus: this.opportunityDetails?.activeInactiveStatus,
            statusId:  this.opportunityDetails.statusId,
            pipelineId: this.opportunityDetails?.pipelineId,
            stageId: this.opportunityDetails?.opportunityStageId
        }

        this.formatCustomAttributeValues(opportunityViewDetails.customAttributeValues);
        this.opportunityViewDetails = opportunityViewDetails;

        this.getColsCount();
    }

    formatCustomAttributeValues(customAttributeValues = {}){
        this.opportunityDetails.customAttributeValues.map(customField=>{
            let value = customField.value;

            switch (customField.formControlId) {
                case FormControlListIds.DatePicker:
                    value = customField.value ? new DatePipe('en').transform(customField.value, 'MM/dd/yyyy') : '';
                    break;
                case FormControlListIds.DropDownList:
                    value = customField.values?.name||"";
                    break;
                case FormControlListIds.MultipleDropDownList:
                    value = customField.multipleValues?.length>0 ? customField.multipleValues.map(val => val.name)?.join(', ') : "";
                    break;
                case FormControlListIds.CheckBox:
                    value = customField.multipleCheckBox?.length > 0 ? customField.multipleCheckBox.join(', ') : "";
                    break;
                case FormControlListIds.Rating:
                    value = customField.ratingId.toString();
                    break;
                case FormControlListIds.ToggleButton:
                    value = customField.toggle ? 'true' : 'false';
                    break;
                case FormControlListIds.Picture:
                    const pictures = customField.customeAttachement;
                    if (pictures?.length) {
                        value = pictures.filter(val=> val?.name).map(val => val.name)?.join(',\n')
                    } else {
                        value = '';
                    }
                    break;
                case FormControlListIds.FileUpload:
                    const files = customField.customeAttachement;
                    if (files?.length) {
                        value = files.filter(val=> val?.name).map(val => val.name)?.join(',\n')
                    } else {
                        value = '';
                    }
                    break;
                default:
                    break;
            }

            customAttributeValues[customField.customAttributeId] = value;
        })
    }

    formatCustomFieldValues() {
        this.opportunityDetails.customAttributeValues.map((element: any)=>{
            if (element.customAttribute && element.customAttribute.formControl && element.customAttribute.formControl.name) {

                element['formControlId'] = element.customAttribute.formControl.id;
                element['field'] = element.customAttribute.formControl.fieldName;

                switch (element.customAttribute.formControl.name) {
                    case 'DropDownList':
                        element.values = element.value ? JSON.parse(element.value) : null;
                        break;
                    case 'MultipleDropDownList':
                        element.multipleValues = element.value ? JSON.parse(element.value) : null;
                        break;
                    case 'CheckBox':
                        element.multipleCheckBox = element.value ? JSON.parse(element.value) : null;
                        break;
                    case 'FileUpload':
                        element.customeAttachement = element.value ? JSON.parse(element.value) : null;
                        break;
                    case 'Picture':
                        element.customeAttachement = element.value ? JSON.parse(element.value) : null;
                        break;
                    case 'DatePicker':
                        element.value = element.value ? new Date(element.value) : '';
                        break;
                    case 'Rating':
                        element.ratingId = element.value ? parseInt(element.value) : 0;
                        break;
                    case 'ToggleButton':
                        element.toggle = (element.value && element.value?.toLowerCase() == 'true') ? true : false;
                        break;
                }
            }
        });
	}


    formCustomValuesForSave(addedCustomAttributes: OpportunityAddEditCustomFields[]){
        addedCustomAttributes.map(customField=>{

            if([FormControlListIds.Number,FormControlListIds.Decimal].includes(customField.formControlId)){
                customField.value = customField.value==null ? "" : toFixedDown(customField.value.toString(), customField.maxLengthAfterDecimal);
            }else if([FormControlListIds.DatePicker].includes(customField.formControlId)){
                customField.value = customField.value ? this.timeZoneService._getCustomDateString(customField.value) : customField.value;
            }

            // switch (customField.formControlId) {
            //     case FormControlListIds.DropDownList:
            //         customField.value = customField.values ? JSON.stringify(customField.values) : null;
            //         break;
            //     case FormControlListIds.MultipleDropDownList:
            //         customField.value = customField.multipleValues ? JSON.stringify(customField.multipleValues) : null;
            //         break;
            //     case FormControlListIds.CheckBox:
            //         customField.value = customField.multipleCheckBox ? JSON.stringify(customField.multipleCheckBox) : null;
            //         break;
            //     case FormControlListIds.FileUpload:
            //         customField.value = customField.customeAttachement ? JSON.stringify(customField.customeAttachement) : null;
            //         break;
            //     case FormControlListIds.Picture:
            //         customField.value = customField.customeAttachement ? JSON.stringify(customField.customeAttachement) : null;
            //         break;
            //     case FormControlListIds.Rating:
            //         customField.value = customField.ratingId ? customField.ratingId.toString() : null;
            //         break;
            //     case FormControlListIds.ToggleButton:
            //         customField.value = customField.toggle ? 'True' : 'False';
            //         break;
            // }
        });

        return addedCustomAttributes;
    }

    //#endregion

    switchToEdit(){
        this.crudType = 'update';
        this.dialogHeader = 'Edit Opportunity';
    }

    getActivityList(){
        this.app.objectId = this.opportunityId;
		this.app.objectType = ObjectNames.OPPORTUNITY;
		// this.app.getAllActivityLog("lastfiveactivity", "allactivity", 1, 5, "", true, true);
    }

    closeOpportunityDialog(){
        this.displayAddEditDialog = false;
        this.closeModal.emit();
    }

    changeStatus(e){
        if(this.crudType!='update') return;

		this.opportunityStatusId = this.opportunityForm.value.isActive ? Status.InActive : Status.Active;;
	    this.displayActiveInactiveModal = true;
    }

    cancelActiveInactiveModal() {
        this.opportunityForm.patchValue({
            isActive: (this.opportunityDetails.statusId==Status.Active)
        })
		this.displayActiveInactiveModal = false;
	}

    saveActiveInactiveModal() {
		this.displayActiveInactiveModal = false;
		this.opportunityDetails.statusId = this.opportunityForm.value.isActive ? Status.Active : Status.InActive;
	}

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }


    loadAllTiers() {
        this.appMainService.isShowSpinner('loadAllTiers');
        this.productsService
            .getAllTiers()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: res => {
                    this.pricebookConfig = res.item1;
                    this.appMainService.isHideSpinner('loadAllTiers');
                },
                error: () => {
                    this.appMainService.isHideSpinner('loadAllTiers');
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
                }
            });
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    //#region AccountName

  chooseAccountCol() {
    this.columnSettingsService.getColumnSettings(this.selectedModule?.id, this.accountChannelId).subscribe(
        resp => {
            let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
            this.manualRuleColumnSetttings = defaultColumnSettings;
        },
        err => {
        }
        );
    }

  openParentAcountDialog(){
    this.chooseAccountCol();
    this.selectedRecordList = this.opportunityForm?.value?.accountId ? ParseHelper.DeepCopy([this.opportunityForm?.value.accountId]) : [];
    this.displayManualPopup = true;
    }

  removeParentAccount() {
      this.selectedParentAccount = null;
      this.opportunityForm.patchValue({
        accountId: null
      })
    }

  saveParentAccount($event) {
      this.selectedRecordList = ParseHelper.DeepCopy($event.selectedReccords);
      if (this.selectedRecordList?.length > 0) {
          this.selectedParentAccount = ParseHelper.DeepCopy(this.selectedRecordList[0]);
          this.opportunityForm.patchValue({
            accountId: this.selectedParentAccount
          })
          this.getAccountContacts(this.opportunityForm.value?.accountId);
          this.getAccountDetailsById(this.opportunityForm.value?.accountId?.id);
          
      }
      this.displayManualPopup = false;
    }

  columnSettingSaved($event){
      this.manualRuleColumnSetttings = $event;
    }

  manualpopupCancelClicked() {
      this.displayManualPopup = false;
    }

    getAccountDetailsById(id) {
        this.appMainService.isShowSpinner('getAccountDetailsById');
        this.accountsHttpService
          .getAccountDetails(id,true)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: (response) => {
              this.accountDetails = response;
              const selectedAccount = response ;
              this.appMainService.isHideSpinner('getAccountDetailsById');
              this.getProjectedCustomAttributes(this.opportunityForm, selectedAccount);
              this.getcurrencyExchangeRate();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('getAccountDetailsById');
                switch (error?.status) {
                    case 404:
                      this.detailsErrorMessage = "You're not permitted to view this account details!";
                      break;
                    default:
                      this.detailsErrorMessage = 'Error occurring when fetching accounts details. Please try after sometimes.';
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Error!',
                        detail: this.detailsErrorMessage,
                      });
                      break;
                  }
            }
          });
      }

      getProjectedCustomAttributes(form , selectedAccount) {
        const customAttributes = form.controls.customAttributeValues.controls;
        const projectedAttributes = customAttributes.filter(attribute => attribute.value?.isMapped);

        projectedAttributes.map((customField) => {
            const fieldName = customField.value?.field;
            const matchingValue = selectedAccount.customAttributeValues?.find(custom => custom?.customAttribute?.fieldName === fieldName);

                const projectedValues = {
                    value: "",
                    values: null,
                    multipleValues: null,
                    multipleCheckBox: null,
                    customeAttachement: null,
                    ratingId: 0,
                    toggle: false
                }

                if(matchingValue){
                    let dataValue = matchingValue?.value;
                    projectedValues.value = dataValue;

                    switch (matchingValue.customAttribute.formControl.name) {
                        case 'DropDownList':
                            dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;
                            projectedValues.values = dataValue;
                            break;
                        case 'MultipleDropDownList':
                            dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;
                            try {
                                dataValue = dataValue ? dataValue?.filter(el => el.name)||[] : [];
                            } catch (e) {
                                dataValue = [];
                            }

                            projectedValues.multipleValues = dataValue;
                            break;
                        case 'CheckBox':
                            dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;
                            projectedValues.multipleCheckBox = dataValue;
                            break;
                        case 'FileUpload':
                            dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;
                            projectedValues.customeAttachement = dataValue;
                            break;
                        case 'Picture':
                            dataValue = ((typeof dataValue === 'string') && dataValue.length) ? JSON.parse(dataValue) : dataValue;
                            projectedValues.customeAttachement = dataValue;
                            break;
                        case 'DatePicker':
                            projectedValues.value = (dataValue ? new Date(dataValue) : '') as any;
                            break;
                        case 'Rating':
                            projectedValues.ratingId = dataValue ? parseInt(dataValue) : 0;
                            break;
                        case 'ToggleButton':
                            projectedValues.toggle = (dataValue && dataValue?.toLowerCase() == 'true') ? true : false;
                            break;
                    }
                }

                customField.patchValue(projectedValues);
          });

    }

    getTotalTaxAmount(subTaxes) {
        return this.opportunityProductToCommonProductModelBuilderService.getTotalTaxAmount(subTaxes);
    }

    getVisibleFieldCount(): number {
        let count = 0;
        for (const key in this.checkedFields) {
            if (this.checkedFields[key]?.enabledInForm) {
                count++;
            }
        }
        return count;
    }

    getColumnFlex() {
        const visibleCount = this.getVisibleFieldCount();
        return visibleCount > 0 ? 100 / visibleCount + "%" : "auto";
    }
    getColsCount(){
        this.cols = 0;
        if(this.checkedFields?.itemNo?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.productDescription?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.unit?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.uom?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.price?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.subTotal?.enabledInForm) this.cols = this.cols + 1;
        // if(this.checkedFields?.productDiscountRate?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.productDiscount?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.tax?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.handlingFeesAmount?.enabledInForm) this.cols = this.cols + 1;
        if(this.checkedFields?.itemTotal?.enabledInForm) this.cols = this.cols + 1;
    }

    /** Multicurrency */

    fetchAccountDetailsById(id) {
        if (!id) return;
        this.appMainService.isShowSpinner("fetchAccountDetailsById");
        this.accountsHttpService
            .getAccountDetails(id, true)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.accountDetails = response;
                    this.getcurrencyExchangeRate();
                    this.appMainService.isHideSpinner("fetchAccountDetailsById");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("fetchAccountDetailsById");
                },
            });
    }

    getcurrencyExchangeRate() {
        this.currencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountDetails?.currencyId)?.exchangeRate;
        this.previousCurrencyExchangeRate = this.orgCurrency?.find((cr) => cr.currencyId == this.accountDetails?.currencyId)?.exchangeRate;
        if (this.crudType && (this.crudType == "update" || this.crudType == "clone" || this.crudType == "view")) {
            this.currencyExchangeRate = Number(this.opportunityDetails?.exchangeRate ?? 1);
            this.previousCurrencyExchangeRate = Number(this.opportunityDetails?.exchangeRate ?? 1);
        }
    }

    closeCurrencyDialog(event: any) {
        this.currencyExchangeRate = event?.formData?.exchangeRate;
        if (event?.formData?.enableRecalculateItemRate) {
            this.recalculateWrapper.value = true;
        }
        this.overlayPanel.hide();
    }

    isBaseCurrency(): boolean {
        return this.baseCurrency?.currencyId == this.accountDetails?.currencyId;
    }

    /** End Multicurrency */

}
